export default class ModulesHelper {
  public static ACCOUNTING_MODULE_NAME = 'accounting';
  public static SUBVENTIONS_MODULE_NAME = 'subventions';
  public static CONDITIONAL_PRICING_MODULE_NAME = 'conditional_pricing';
  public static ACTIVITIES_MODULE_NAME = 'activities';
  public static SUBSCRIPTIONS_MODULE_NAME = 'subscriptions';
  public static CONTRACTS_DOCUMENTS_MODULE_NAME = 'contracts_documents';
  public static COMMUNICATIONS_MODULE_NAME = 'communications';
  public static TAX_MANAGEMENT_MODULE_NAME = 'tax_management';
  public static BOOKINGS_MODULE_NAME = 'bookings';
  public static CONTACTS_MODULE_NAME = 'contacts';
  public static CMS_MODULE_NAME = 'cms';
  public static CERTIFICATES_MODULE_NAME = 'certificates';
  public static ACCOUNTING_INTEGRATIONS_MODULE_NAME = 'accounting_integrations';
  public static POS_MODULE_NAME = 'point_of_sale';
  public static PAYMENT_TERMINALS_MODULE_NAME = 'payment_terminals';
  public static ENTRIES_MODULE_NAME = 'entries';
  public static ACCESS_CONTROL_MODULE_NAME = 'access_control';
  public static CODA_MANAGEMENT_MODULE_NAME = 'coda_management';
  public static SALE_SESSION_MANAGEMENT = 'sale_session_management';
  public static TAX_CERTIFICATES_MODULE_NAME = 'tax_certificates';
  public static ONLINE_BOOKING_V2_MODULE_NAME = 'online_booking_v2';
  public static ANYBUDDY_MODULE_NAME = 'anybuddy';
  public static TPPWB_SYNC_MODULE_NAME = 'tppwb_sync';
  public static VIRTUAL_WALLET_MODULE_NAME = 'virtual_wallet';
}
